import * as contentful from 'contentful';
import React, { createContext, useState, useEffect } from 'react';
import { Loader, useBrandDetails } from 'dw-au-react-components';

export const ContentfulContext = createContext();

export const ContentfulProvider = ({ children, type }) => {
	const [loading, setLoading] = useState(true);
	const [plpSeoCopy, setPlpSeoCopy] = useState(null);
	const [wineType, setWineType] = useState('wines');
	const brandData = useBrandDetails();
	const pageLocation = location.pathname;

	const getEnv = () => {
		if (
			location.host.indexOf('localhost') > -1 ||
			location.host.indexOf('webdev00') > -1 ||
			location.host.indexOf('rebrand.') > -1 ||
			location.host.indexOf('st.') > -1 ||
			location.host.indexOf('uat.') > -1
		) {
			return 'uat';
		} else {
			return 'live';
		}
	};

	let currentEnv = getEnv();

	const client = contentful.createClient({
		space: '759ah7skns84',
		...(currentEnv !== 'live' && { host: 'preview.contentful.com' }),
		accessToken:
			currentEnv === 'live'
				? 'WRSJ8s9akgwwr-ejARj8VUrKv67gUu8NhjnhYZu35-0'
				: 'lo_AIhv7unvx5CBSv8cMWMtugozF1y7_aL8S_M-9Aqw'
	});

	const params = {
		content_type: 'plpVarietyCopySeo'
	};
	params['fields.brand[match]'] = brandData.tag;
	params['fields.slug[in]'] = pageLocation
		.split('/')
		.join(',')
		.slice(1);

	const fetchContentfulData = () => {
		setLoading(true);

		client
			.getEntries(params)
			.then((response) => {
				setPlpSeoCopy(response?.items[0]?.fields);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const findWineType = () => {
		let wineType = 'wines';

		if (pageLocation.includes('red-wine') || pageLocation.includes('dry-red')) {
			wineType = 'red-wine';
		} else if (
			pageLocation.includes('white-wine') ||
			pageLocation.includes('dry-white')
		) {
			wineType = 'white-wine';
		} else if (
			pageLocation.includes('rose-wine') ||
			pageLocation.includes('rosé-wine')
		) {
			wineType = 'rose';
		} else if (pageLocation.includes('mixed')) {
			wineType = 'mixed';
		} else if (pageLocation.includes('sparkling')) {
			wineType = 'sparkling';
		}

		setWineType(wineType);
	};

	useEffect(() => {
		fetchContentfulData();
		if (type === 'top') {
			findWineType();
		}
	}, []);

	return (
		<ContentfulContext.Provider
			value={{
				plpSeoCopy,
				wineType
			}}
		>
			{loading ? <Loader /> : children}
		</ContentfulContext.Provider>
	);
};
